import { useAppSelector } from '@/shared/hooks/useStore';
import { useGlobalRunNotifications } from '@/viewmodel/features/observability/hooks/useGlobalRunNotifications';
import { selectCurrentProject } from '@/viewmodel/features/project';
import { selectCurrentWorkspace } from '@/viewmodel/features/workspace';

export function useRunNotificationsViewModel(): void {
  const workspaceId = useAppSelector(selectCurrentWorkspace)?.id;
  const projectId = useAppSelector(selectCurrentProject)?.id;
  useGlobalRunNotifications(projectId, workspaceId);
}
